import { PHONE_1, PHONE_2, PHONE_3, PHONE_4 } from "constants/configConstants";

export const copies = {
  get_help: {
    title: "Get Help",
    subtext: `We’re here for you, <b>get free expert consultation</b> for your dream home now!`,
    successFirstUserSubtext: "Our team will contact you shortly on your registered details.",
    successSecondUserSubtext: "Our team will contact you shortly on your registered details.",
    successFirstUserSubtextNotAvailable:
      "Our team will contact you shortly on your registered details.",
    successSecondUserSubtextNotAvailable:
      "Our team will contact you shortly on your registered details.",
  },
  ask_question_faq_cta: {
    title: "Ask Question",
    subtext:
      "<b>Spot-on choice and perfect timing!</b> Your home is just a few steps away. Enquiry is absolutely <b>free.</b>",
    successFirstUserSubtext: "Our team will contact you shortly on your registered details.",
    successSecondUserSubtext:
      "We have your details from your previous enquiry. Our team will contact you shortly on your registered details.",
    successFirstUserSubtextNotAvailable:
      "Our team will contact you shortly on your registered details.",
    successSecondUserSubtextNotAvailable:
      "We have your details from your previous enquiry. Our team will contact you shortly on your registered details.",
  },

  enquire: {
    title: "Enquire Now",
    subtext:
      "<b>Spot-on choice and perfect timing!</b> Your home is just a few steps away. Enquiry is absolutely <b>free.</b>",
    successFirstUserSubtext: "Our team will contact you shortly on your registered details.",
    successFirstUserSubtextNotAvailable:
      "This property is sold out. We have your details and will contact you soon. Keep browsing!",
    successSecondUserSubtext:
      "We have your details from your previous enquiry. Our team will contact you shortly on your registered details.",
    successSecondUserSubtextNotAvailable:
      "This property is sold out. We have your details and will contact you soon. Keep browsing!",
  },
  virtual_tour_enquiry: {
    title: "Live Virtual tour request",
    subtext:
      "Your ideal student accommodation is a few steps away! Please fill in your details below so we can find you a new home!",
    successFirstUserSubtext:
      "Our team will get in touch with you regarding the next steps. Meanwhile, you can check other properties.",
    successSecondUserSubtext:
      "Our team will get in touch with you regarding the next steps. Meanwhile, you can check other properties.",
    successFirstUserSubtextNotAvailable:
      "Our team will get in touch with you regarding the next steps. Meanwhile, you can check other properties.",
    successSecondUserSubtextNotAvailable:
      "Our team will get in touch with you regarding the next steps. Meanwhile, you can check other properties.",
  },
  referred_by_enquiry: {
    title: "Enquire Now",
    subtext:
      "Spot-on choice and perfect timing! Your home is just a few steps away. Enquiry is absolutely free.",
    successFirstUserSubtext: "Our team will contact you shortly on your registered details.",
    successSecondUserSubtext:
      "Our team will get in touch with you regarding the next steps. Meanwhile, you can check other properties.",
    successFirstUserSubtextNotAvailable:
      "Our team will contact you shortly on your registered details.",
    successSecondUserSubtextNotAvailable:
      "Our team will get in touch with you regarding the next steps. Meanwhile, you can check other properties.",
  },
  partner_enquire: {
    title: "Help us with your details ",
    subtext: "Please fill in your details below so we can find you a new home!",
    successFirstUserSubtext: "Our team will contact you shortly on your registered details.",
    successSecondUserSubtext:
      "We have your details from your previous enquiry. Our team will contact you shortly on your registered details.",
    successFirstUserSubtextNotAvailable:
      "Our team will contact you shortly on your registered details.",
    successSecondUserSubtextNotAvailable:
      "We have your details from your previous enquiry. Our team will contact you shortly on your registered details.",
  },

  book_now: {
    title: "Book Now",
    subtext:
      "<b>Spot-on choice and perfect timing!</b> Your home is just a few steps away. Guaranteed comfort awaits!",
    successFirstUserSubtext: "Our team will contact you shortly on your registered details.",
    successSecondUserSubtext:
      "We have your details from your previous enquiry. Our team will contact you shortly on your registered details.",
    successFirstUserSubtextNotAvailable:
      "This property is sold out. We have your details and will contact you soon. Keep browsing!",
    successSecondUserSubtextNotAvailable:
      "This property is sold out. We have your details and will contact you soon. Keep browsing!",
  },

  apply_now: {
    title: "Apply Now",
    subtext:
      "<b>Spot-on choice and perfect timing!</b> Your home is just a few steps away. Guaranteed comfort awaits!",
    successFirstUserSubtext: "Our team will contact you shortly on your registered details.",
    successSecondUserSubtext:
      "We have your details from your previous enquiry. Our team will contact you shortly on your registered details.",
  },

  contact_us: {
    title: "Seeking Different Dates",
    subtext:
      "<b>Need alternative dates?</b> Let us know via the form below. We'll find the perfect match for you!",
    successFirstUserSubtext: "Our team will contact you shortly on your registerd details.",
    successSecondUserSubtext: "Our team will contact you shortly on your registerd details.",
    successFirstUserSubtextNotAvailable:
      "Our team will contact you shortly on your registerd details.",
    successSecondUserSubtextNotAvailable:
      "Our team will contact you shortly on your registerd details.",
  },

  join_waitlist: {
    title: "Join Waitlist",
    subtext:
      "Want to increase your chances of securing a spot here? Fill out this form & you’ll be notified first.",
    successFirstUserSubtext:
      "We’ll notify you when this room is available and contact you shortly on your registerd details.",
    successSecondUserSubtext:
      "We’ll notify you when this room becomes available and contact you shortly on your registerd details.",
    successFirstUserSubtextNotAvailable:
      "We’ll notify you when this room becomes available and contact you shortly on your registerd details.",
    successSecondUserSubtextNotAvailable:
      "We’ll notify you when this room becomes available and contact you shortly on your registerd details.",
  },
  edit_details: {
    title: "Edit Details",
    subtext: "Your details are safe with us, let's get them updated",
    successFirstUserSubtext:
      "Your details are updated, our team will contact you shortly on your registerd details!",
    successSecondUserSubtext:
      "Your details are updated, our team will contact you shortly on your registerd details!",
    successFirstUserSubtextNotAvailable:
      "This property is sold out. We have your details and will contact you soon. Keep browsing!",
    successSecondUserSubtextNotAvailable:
      "This property is sold out. We have your details and will contact you soon. Keep browsing!",
  },
  generic_form: {
    title: "Want Accommodation of your choice?",
    subtext: "Connect with an housing expert for free personal assistance.",
    successFirstUserSubtext: "Our team will contact you shortly on your registered details.",
    successSecondUserSubtext: "Our team will contact you shortly on your registered details.",
    successFirstUserSubtextNotAvailable:
      "Our team will contact you shortly on your registerd details.",
    successSecondUserSubtextNotAvailable:
      "Our team will contact you shortly on your registerd details.",
  },
  apply_for_fall: {
    title: "Apply for Fall’26",
    subtext:
      "Fall’26 prices are yet to be confirmed. Submit your details early to reserve your spot and receive updates once final prices are released.",
    successFirstUserSubtext:
      "We'll reach out when this room is available. Until then, explore the property further to discover what it offers!",
    successSecondUserSubtext:
      "We'll reach out when this room is available. Until then, explore the property further to discover what it offers!",
    successFirstUserSubtextNotAvailable:
      "We'll reach out when this room is available. Until then, explore the property further to discover what it offers!",
    successSecondUserSubtextNotAvailable:
      "We'll reach out when this room is available. Until then, explore the property further to discover what it offers!",
  },
};

export const COUNTRIES = {
  AU: "AU",
  US: "US",
  GB: "GB",
  IN: "IN",
};

export const OPENING_SOURCE = {
  GET_HELP: "get_help",
  SEARCH_INVENTORY_ENQUIRE: "search_inventory_enquire",
  CLICKED_BOOK_ENQUIRE_NOW_PROPERTY: "clicked_book_enquire_now_property",
  BOOK_NOW: "book_now",
  APPLY_NOW: "apply_now",
  APPLY_FOR_FALL: "apply_for_fall",
  JOIN_WAITLIST: "join_waitlist",
  CONTACT_US: "contact_us",
  QUESTION_ENQUIRY_CONNECT_CTA: "questions_enquiry_connect_cta",
  FAQ_QUESTION_CTA: "ask_question_faq_cta",
  GALLERY_MODAL_BOOK_CLICK: "clicked_gallery_book_now_button",
};
export const INTAKE_OPTIONS_MAP = [
  {
    label: "January-March",
    value: "january_to_march",
  },
  {
    label: "April-June",
    value: "april_to_june",
  },
  {
    label: "July-September",
    value: "july_to_september",
  },
  {
    label: "October-December",
    value: "october_to_december",
  },
];

export const dialerURL = (country: string) => {
  switch (country) {
    case COUNTRIES.IN:
      return { url: `tel:${PHONE_2.full_number}`, number: PHONE_2.full_number };
    case COUNTRIES.US:
      return { url: `tel:${PHONE_3.full_number}`, number: PHONE_3.full_number };
    case COUNTRIES.AU:
      return { url: `tel:${PHONE_4.full_number}`, number: PHONE_4.full_number };
    default:
      return { url: `tel:${PHONE_1.full_number}`, number: PHONE_1.full_number };
  }
};

export const CTA_SOURCE_MAPPING = {
  get_help: "Get_Help_Lead_CTA",
  search_inventory_enquire: "clicked_property_card_contact_newleadform",
  clicked_book_enquire_now_property: "clicked_book_enquire_now_property_newleadform",
  book_now: "clicked_book_tenancy_room",
  join_waitlist: "clicked_join_waitlitst_tenancy_room",
  contact_us: "clicked_contact_us",
  questions_enquiry_connect_cta: "questions_enquiry_connect_cta",
  ask_question_faq_cta: "ask_question_faq_cta",
  referred_by_enquiry: "referred_by_enquiry",
  apply_now: "apply_now_tenency_cta",
  apply_for_fall: "apply_for_fall_tenency_cta",
};

export const LEAD_SOURCE_MAPPING = {
  get_help: "clicked_get_help",
  search_inventory_enquire: "search_inventory_enquire",
  clicked_book_enquire_now_property: "clicked_book_enquire_now_property",
  book_now: "clicked_book_tenancy_room",
  join_waitlist: "clicked_join_waitlist_room",
  contact_us: "clicked_contact_us",
  questions_enquiry_connect_cta: "questions_enquiry_connect_cta",
  ask_question_faq_cta: "ask_question_faq_cta",
  referred_by_enquiry: "referred_by_enquiry",
  apply_for_fall: "clicked_apply_for_fall",
};

export const BOOKFORM_SOURCE_MAP = {
  get_help: "get_help",
  search_inventory_enquire: "search_inventory_enquire",
  clicked_book_enquire_now_property: "clicked_book_enquire_now_property",
  book_now: "enquire_property",
  join_waitlist: "join_waitlist",
  contact_us: "book_tenancy",
  questions_enquiry_connect_cta: "questions_enquiry_connect_cta",
  ask_question_faq_cta: "ask_question_faq_cta",
  clicked_gallery_book_now_button: "clicked_gallery_book_now_button",
  apply_for_fall: "apply_for_fall",
};
